export class Geometry {
    valueOf() {
        return this.toJSON();
    }
    toString() {
        return JSON.stringify(this.toJSON());
    }
}
//# sourceMappingURL=geometry.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6-geometry/es/geometry.js
// module id = null
// module chunks = 